var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9847 0.125781C9.5121 0.470313 7.11855 1.44375 5.08629 3.06797L9.45564 7.30078C11.025 5.34297 11.9 2.86016 11.9847 0.125781ZM14 11.7031L22.9137 3.06797C20.5202 1.15391 17.6298 0.142187 14.7 0C14.6323 3.49453 13.4863 6.68828 11.3863 9.17109L14 11.7031ZM3.16694 4.92734C1.49032 6.89609 0.485484 9.21484 0.129839 11.6102C2.95242 11.5281 5.52097 10.6805 7.53629 9.16016L3.16694 4.92734ZM18.5331 16.0945C21.0903 14.0656 24.3871 12.9555 28 12.8844C27.8532 10.0461 26.8089 7.24609 24.8331 4.92734L15.9194 13.5625L18.5331 16.0945ZM14 15.4219L5.08629 24.057C7.47984 25.9656 10.3702 26.9828 13.3 27.125C13.3734 23.625 14.5194 20.4312 16.6137 17.9539L14 15.4219ZM24.8331 22.1977C26.5097 20.2289 27.5145 17.9102 27.8702 15.5148C25.0419 15.6023 22.479 16.45 20.4637 17.9648L24.8331 22.1977ZM9.46694 11.0305C6.90403 13.0648 3.60726 14.1805 0 14.2406C0.146774 17.0789 1.19113 19.8789 3.16694 22.1977L12.0806 13.5625L9.46694 11.0305ZM16.0153 26.9992C18.4879 26.6547 20.8815 25.6812 22.9137 24.057L18.5444 19.8242C16.9806 21.7766 16.1056 24.2648 16.0153 26.9992Z",
    fill: "#1478FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9c419ae52d6f98ac38fab59cf5409d67.svg";
export { ForwardRef as ReactComponent };